import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async Thunk pour récupérer les blocs dynamiques actifs depuis l'API
export const fetchBlocsActifs = createAsyncThunk(
  'blocs/fetchBlocsActifs',
  async (_, { rejectWithValue }) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.get(`${apiUrl}blocs-actifs`);

      // Vérification de la structure de la réponse et retourner les données
      // console.log(response.data.faqs)
      if (response.data) {
        return response.data; // Retourne toute la réponse contenant les différentes sections (articles, services, etc.)
      } else {
        return rejectWithValue('Structure des données incorrecte');
      }
    } catch (error) {
      return rejectWithValue(error.message); // Retourne l'erreur de l'API
    }
  }
);

const blocsSlice = createSlice({
  name: 'blocs',
  initialState: {
    articles: {},
    faqs: {},
    professionnels: {},
    services: {},
    testimonials: {},
    villes: [],
    ccms: {},
    status: 'idle', // 'idle', 'loading', 'succeeded', 'failed'
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlocsActifs.pending, (state) => {
        state.status = 'loading'; // Statut en cours de chargement
      })
      .addCase(fetchBlocsActifs.fulfilled, (state, action) => {
        state.status = 'succeeded'; // Statut réussi
        state.articles = action.payload.articles || {}; // Stocke les articles
        state.faqs = action.payload.faqs || {}; // Stocke les FAQs
        state.professionnels = action.payload.professionnels || {}; // Stocke les professionnels
        state.services = action.payload.services || {}; // Stocke les services
        state.testimonials = action.payload.testimonials || {}; // Stocke les témoignages
        state.villes = action.payload.villes || []; // Stocke les villes
        state.ccms = action.payload.ccms || []; // Stocke les villes
      })
      .addCase(fetchBlocsActifs.rejected, (state, action) => {
        state.status = 'failed'; // Statut d'échec
        state.error = action.payload || action.error.message; // Stocke l'erreur
      });
  },
});

export default blocsSlice.reducer;
